    import React from "react";
    import {useLaravelReactI18n} from "laravel-react-i18n";
    import {usePage} from "@inertiajs/react";

    export default function MonthlyClosures(props) {
        const { t,getLocales } = useLaravelReactI18n();
        const {} = usePage().props;
        return (
            <>
                <div className="mt-5 d-flex justify-content-center">
                    <h1>{t('MonthlyClosures')}</h1>
                </div>
                <div className="m-5">
                    <Card style={{ width: '18rem' }}>
                        <Card.Header>Dashboard</Card.Header>
                        <Card.Body>Test</Card.Body>
                    </Card>
                </div>
            </>
        );
    }
